<template>
    <div class="footer">
        Bu kısmı daha önce svelte versiyonu ile de yapmıştım onun <a href="https://clever-jennings-59b278.netlify.app/" target="_blank">link</a>inide bırakıyorum. 
        <br>  <br> 
        Proje başlangıç tarihi saati : <strong>25/11/2021</strong>
        <br>  <br>
        Proje bitiş tarihi : <strong>26/11/2021</strong>
        <br>  <br>

        <a href="https://www.linkedin.com/in/emrecaneskimez/">LinkedIn</a>
    </div>
</template>


<style scoped>
.footer{
    width: 100%;
    position: absolute;
    top:1100px;
}
</style>